<template>
  <div>
    <Modal
      v-model="isShowLoginModal"
      :mask-closable="false"
      @on-ok="inputSubmit"
      @on-cancel="handleClose"
    >
      <div slot="header" class="login-tab-block">
        <div
          class="login-tab"
          :class="{ selected: inputsStatus === 'login' }"
          @click="changeInputStatus('login')"
        >
          {{ $t("message.loginModal.titleLogin") }}
        </div>
        <div class="col-line"></div>
        <div
          class="login-tab"
          :class="{ selected: inputsStatus === 'register' }"
          @click="changeInputStatus('register')"
        >
          {{ $t("message.loginModal.titleRegister") }}
        </div>
      </div>
      <!--            登录部分 start -->
      <Form
        v-if="inputsStatus === 'login'"
        :model="loginInputs"
        :rules="ruleLoginInputs"
        :label-width="100"
      >
        <form-item
          :label="$t('message.loginModal.inputEmail')"
          prop="loginEmail"
        >
          <i-input
            type="text"
            v-model="loginInputs.loginEmail"
            clearable
            :placeholder="$t('message.loginModal.emailPlaceholder')"
          >
            <Icon type="ios-mail" size="20" slot="prepend"></Icon>
          </i-input>
        </form-item>
        <form-item
          :label="$t('message.loginModal.inputPassword')"
          prop="loginPassword"
        >
          <i-input
            type="password"
            v-model="loginInputs.loginPassword"
            clearable
            :placeholder="$t('message.loginModal.passwordPlaceholder')"
          >
            <Icon type="md-lock" size="20" slot="prepend"></Icon>
          </i-input>
        </form-item>
      </Form>
      <!--            登录部分 end-->

      <!--            注册部分 start -->
      <Form
        v-if="inputsStatus === 'register'"
        :model="registerInputs"
        :rules="ruleRegisterInputs"
        :label-width="100"
      >
        <form-item
          :label="$t('message.loginModal.inputEmail')"
          prop="registerEmail"
        >
          <i-input
            type="text"
            v-model="registerInputs.registerEmail"
            clearable
            :placeholder="$t('message.loginModal.emailPlaceholder')"
          >
            <Icon type="ios-mail" size="20" slot="prepend"></Icon>
          </i-input>
        </form-item>
        <form-item
          :label="$t('message.loginModal.inputPassword')"
          prop="registerPassword"
        >
          <i-input
            type="password"
            v-model="registerInputs.registerPassword"
            clearable
            :placeholder="$t('message.loginModal.passwordPlaceholder')"
          >
            <Icon type="md-lock" size="20" slot="prepend"></Icon>
          </i-input>
        </form-item>
        <form-item
          :label="$t('message.loginModal.inputConfirmPassword')"
          prop="registerConfirmPassword"
        >
          <i-input
            type="password"
            v-model="registerInputs.registerConfirmPassword"
            clearable
            :placeholder="$t('message.loginModal.confirmPasswordPlaceholder')"
          >
            <Icon type="md-lock" size="20" slot="prepend"></Icon>
          </i-input>
        </form-item>
      </Form>
      <!--            注册部分 end-->
    </Modal>
  </div>
</template>

<script>
import { emailValidate, empty, urlRequest } from "../../common/common";
import { mapActions, mapMutations } from "vuex";

export default {
  name: "LoginModal",

  props: {
    isShowLogin: Boolean,
    email: String,
    // 登录后的后续处理方法
    handler: Function,
  },

  mounted() {
    console.log("props isShowLogin: ", this.isShowLogin);
    console.log("data isShowLoginModal: ", this.isShowLoginModal);
    this.loginInputs.loginEmail = this.email;
    this.registerInputs.registerEmail = this.email;
  },

  data() {
    return {
      // 对话框状态：登录对话框login， 注册对话框register
      inputsStatus: "login",
      // 登录输入内容
      loginInputs: {
        loginEmail: "",
        loginPassword: "",
      },
      // 登录输入校验
      ruleLoginInputs: {
        loginEmail: [
          {
            required: true,
            message: this.$t("message.loginModal.emailRequiredValidate"),
            trigger: "blur",
          },
          {
            type: "email",
            message: this.$t("message.loginModal.emailTypeValidate"),
            trigger: "blur",
          },
        ],
        loginPassword: [
          {
            required: true,
            message: this.$t("message.loginModal.passwordRequiredValidate"),
            trigger: "blur",
          },
          {
            type: "string",
            min: 6,
            message: this.$t("message.loginModal.passwordLengthValidate"),
            trigger: "blur",
          },
        ],
      },

      // 注册输入内容
      registerInputs: {
        registerEmail: "",
        registerPassword: "",
        registerConfirmPassword: "",
      },
      // 注册输入校验
      ruleRegisterInputs: {
        registerEmail: [
          {
            required: true,
            message: this.$t("message.loginModal.emailRequiredValidate"),
            trigger: "blur",
          },
          {
            type: "email",
            message: this.$t("message.loginModal.emailTypeValidate"),
            trigger: "blur",
          },
        ],
        registerPassword: [
          {
            required: true,
            message: this.$t("message.loginModal.passwordRequiredValidate"),
            trigger: "blur",
          },
          {
            type: "string",
            min: 6,
            message: this.$t("message.loginModal.passwordLengthValidate"),
            trigger: "blur",
          },
        ],
        registerConfirmPassword: [
          {
            required: true,
            message: this.$t("message.loginModal.passwordRequiredValidate"),
            trigger: "blur",
          },
          {
            type: "string",
            min: 6,
            message: this.$t("message.loginModal.passwordLengthValidate"),
            trigger: "blur",
          },
        ],
      },
    };
  },

  watch: {
    email(newEmail) {
      this.loginInputs.loginEmail = newEmail;
      this.registerInputs.registerEmail = newEmail;
    },
  },

  methods: {
    ...mapActions([
      // 获取订单列表数据
      "getOrderList",
    ]), handleClose() {
    console.log("Modal closed");
    this.isShowLoginModal = false;
  },
    info() {
      this.$Message.info("This is a info tip");
    },
    ...mapMutations([
      // 修改登录状态
      "setLoginStatus",
      // 保存用户信息
      "setUserInfo",
    ]),

    // 改变登录或注册状态
    changeInputStatus(status) {
      if (status === "login" || status === "register") {
        this.inputsStatus = status;
      }
    },

    // 提交登录或注册请求
    inputSubmit() {
      // 登录请求
      if (this.inputsStatus === "login") {
        // 网络请求之前参数校验
        if (empty(this.loginInputs.loginEmail)) {
          this.$Message.error(
            this.$t("message.loginModal.emailRequiredValidate")
          );
          return;
        }
        if (!emailValidate(this.loginInputs.loginEmail)) {
          this.$Message.error(this.$t("message.loginModal.emailTypeValidate"));
          return;
        }
        if (this.loginInputs.loginPassword.length < 6) {
          this.$Message.error(
            this.$t("message.loginModal.passwordLengthValidate")
          );
          return;
        }
        urlRequest({
          url: this.api.login,
          method: "POST",
          data: {
            email: this.loginInputs.loginEmail,
            password: this.loginInputs.loginPassword,
          },
          isShowMask: false,
        }).then((res) => {
          // 登录成功，将相关信息写入缓存并更新状态
          if (res.data.code === 200) {
            let { token, userInfo } = res.data.data;
            console.log("登录信息", res.data);

            localStorage.setItem("token", token);
            localStorage.setItem("userInfo", JSON.stringify(userInfo));

            this.$emit("loginedHandle");
            this.setLoginStatus(true);
            this.setUserInfo(userInfo);
          } else {
            this.info();
          }
          // 后续处理方法
          console.log("7878: ", this.handler);
          if (!empty(this.handler)) {
            console.log("后续处理方法");
            this.handler();
          }
          // 关闭登陆对话框
          this.isShowLoginModal = false;
          location.reload();
        });
      } else if (this.inputsStatus === "register") {
        // 注册输入校验
        if (empty(this.registerInputs.registerEmail)) {
          this.$Message.error(
            this.$t("message.loginModal.emailRequiredValidate")
          );
          return;
        }
        if (!emailValidate(this.registerInputs.registerEmail)) {
          this.$Message.error(this.$t("message.loginModal.emailTypeValidate"));
          return;
        }
        if (this.registerInputs.registerPassword.length < 6) {
          this.$Message.error(
            this.$t("message.loginModal.passwordLengthValidate")
          );
          return;
        }
        if (
          this.registerInputs.registerPassword !==
          this.registerInputs.registerConfirmPassword
        ) {
          this.$Message.error(
            this.$t("message.loginModal.confirmPasswordSomeValidate")
          );
          return;
        }
        console.log("注册请求");
        urlRequest({
          url: this.api.register,
          method: "POST",
          data: {
            email: this.registerInputs.registerEmail,
            password: this.registerInputs.registerPassword,
            repassword: this.registerInputs.registerConfirmPassword,
            cname: "",
          },
          isShowMask: false,
        }).then((res) => {
          // 注册成功，将相关信息写入缓存并更新状态
          let { token, userInfo } = res.data.data;
          localStorage.setItem("token", token);
          localStorage.setItem("userInfo", JSON.stringify(userInfo));
          this.$emit("loginedHandle");
          this.$store.commit("setLoginStatus", true);
          this.setUserInfo(userInfo);
          location.reload();
          // 后续处理方法
          if (!empty(this.handle)) {
            console.log("后续处理方法");
            this.handler();
          }
          // 关闭登陆对话框
          this.isShowLoginModal = false;
        });
      }
    },
  },

  computed: {
    // 是否展示登录对话框
    isShowLoginModal: {
      get() {
        return this.isShowLogin;
      },
      set: function (val) {
        this.$emit("updateShowLoginModalStatus", val);
        return val;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/style/mainStyle.scss";
@import "LoginModal.scss";
</style>
